export const encode = (value: unknown) => {
  const urlEncoded = encodeURIComponent(JSON.stringify(value))

  return typeof window === 'undefined'
    ? Buffer.from(urlEncoded).toString('base64')
    : window.btoa(urlEncoded)
}

export const decode = (value: string) => {
  const urlDecoded = decodeURIComponent(
    typeof window === 'undefined'
      ? Buffer.from(value, 'base64').toString()
      : window.atob(value),
  )

  return JSON.parse(urlDecoded)
}
